import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import MiniToggleSwitch from '../../../components/ToggleSwitchSmall/ToggleSwitchSmall';
import { Box, TextField } from '@material-ui/core';

const Wrapper = styled.div``;
const ToggleWrapper = styled.div`
  margin: 15px 0 10px 0;
  display: flex;
  gap: 7px;
`;
const NoteHead = styled.div`
  font-size: 17px;
  color: #191818;
  font-weight: 600;
  margin-bottom: 5px;
`;
const NoteHeadNormal = styled.span`
  font-size: 17px;
  color: #191818;
  font-weight: normal;
`;
const SubHead = styled.div`
  font-size: 17px;
  color: #191818;
  font-weight: 600;
  margin-bottom: 15px;
`;
const ErrorSpan = styled.div`
  color: red;
  font-size: 12px;
`;
export const RewardsScanToPay = ({
  values,
  isAllProductsPOSMappingIDsSelected,
  setIsAllProductsPOSMappingIDsSelected,
  setFieldValue,
  indexItem,
  currentSource,
  isAllCombosPOSMappingIDsSelected,
  setIsAllCombosPOSMappingIDsSelected,
  posMappingStringValue,
  posMappingStringValueCombos,
  handleChangeIDs,
  selectedOfferTypes,
  isQuickServiceProductsNotVisible,
  isQuickServiceCombosNotVisible,
  shouldShowSeparateCombos,
}) => {
  const isNotFirstTimeOffer =
    values?.offer_details?.template_name !== 'first-time';

  const showQuickServiceTextFieldForProducts =
    isNotFirstTimeOffer &&
    !isAllProductsPOSMappingIDsSelected &&
    selectedOfferTypes?.['quickservice']?.includes('products');

  const showQuickServiceTextFieldForCombos =
    isNotFirstTimeOffer &&
    !isAllCombosPOSMappingIDsSelected &&
    selectedOfferTypes?.['quickservice']?.includes('combos');

  const showOtherScanToPayTextField =
    !isAllProductsPOSMappingIDsSelected && isNotFirstTimeOffer;
  return (
    <Wrapper>
      {currentSource === 'quickservice' ? (
        <>
          <ToggleWrapper
            style={{
              display:
                isNotFirstTimeOffer && !isQuickServiceProductsNotVisible
                  ? 'flex'
                  : 'none',
            }}
          >
            <MiniToggleSwitch
              checked={isAllProductsPOSMappingIDsSelected}
              onChange={(event) => {
                setIsAllProductsPOSMappingIDsSelected(event.target.checked);
                if (event.target.checked) {
                  setFieldValue(
                    `conditionValue[${indexItem}].reward.products`,
                    []
                  );
                }
              }}
              disabled={!isNotFirstTimeOffer}
            />
            <span>{`Associate offer to all products`}</span>
          </ToggleWrapper>
          <Box
            sx={{
              display: showQuickServiceTextFieldForProducts ? 'flex' : 'none',
              flexDirection: 'column',
              mb: 2,
            }}
          >
            <NoteHead>
              {shouldShowSeparateCombos &&
                'Add POS mapping IDs of the Products that will be eligible for the discount.'}
            </NoteHead>
            <TextField
              multiline
              placeholder='Type POS IDs'
              name={`conditionValue[${indexItem}].reward.products`}
              value={posMappingStringValue}
              onChange={(e) =>
                handleChangeIDs(e, setFieldValue, indexItem, 'products')
              }
              variant='outlined'
              style={{ width: '100%' }}
              sx={{ mb: 2 }}
            />
            {values.conditionValue[indexItem]?.reward.products?.length ===
              0 && <ErrorSpan>Required</ErrorSpan>}
          </Box>
          <ToggleWrapper
            style={{
              display:
                isNotFirstTimeOffer && !isQuickServiceCombosNotVisible
                  ? 'flex'
                  : 'none',
            }}
          >
            <MiniToggleSwitch
              checked={isAllCombosPOSMappingIDsSelected}
              onChange={(event) => {
                setIsAllCombosPOSMappingIDsSelected(event.target.checked);
                if (event.target.checked) {
                  setFieldValue(
                    `conditionValue[${indexItem}].reward.combos`,
                    []
                  );
                }
              }}
              disabled={!isNotFirstTimeOffer}
            />
            <span>{`Associate offer to all combos`}</span>
          </ToggleWrapper>

          <Box
            sx={{
              display: showQuickServiceTextFieldForCombos ? 'flex' : 'none',
              flexDirection: 'column',
              mb: 2,
            }}
          >
            <NoteHead>
              Add POS mapping IDs of the combos that will be eligible for the
              discount
            </NoteHead>
            <TextField
              multiline
              placeholder='Type POS IDs'
              name={`conditionValue[${indexItem}].reward.combos`}
              value={posMappingStringValueCombos}
              onChange={(e) =>
                handleChangeIDs(e, setFieldValue, indexItem, 'combos')
              }
              variant='outlined'
              style={{ width: '100%' }}
              sx={{ mb: 2 }}
            />
            {values.conditionValue[indexItem]?.reward?.combos?.length === 0 && (
              <ErrorSpan>Required</ErrorSpan>
            )}
          </Box>
        </>
      ) : (
        <>
          <ToggleWrapper
            style={{
              display:
                isNotFirstTimeOffer && !isQuickServiceCombosNotVisible
                  ? 'flex'
                  : 'none',
            }}
          >
            <MiniToggleSwitch
              checked={isAllProductsPOSMappingIDsSelected}
              onChange={(event) => {
                setIsAllProductsPOSMappingIDsSelected(event.target.checked);
                if (event.target.checked) {
                  setFieldValue(
                    `conditionValue[${indexItem}].reward.products`,
                    []
                  );
                }
              }}
              disabled={!isNotFirstTimeOffer}
            />
            <span>{`Associate offer to all menu items`}</span>
          </ToggleWrapper>
          <Box
            sx={{
              display: showOtherScanToPayTextField ? 'flex' : 'none',
              flexDirection: 'column',
              mb: 2,
            }}
          >
            <NoteHead>
              {shouldShowSeparateCombos &&
                'Add POS mapping IDs of the menu items that will be eligible for the offer.'}
            </NoteHead>
            <TextField
              multiline
              placeholder='Type POS IDs'
              name={`conditionValue[${indexItem}].reward.products`}
              value={posMappingStringValue}
              onChange={(e) =>
                handleChangeIDs(e, setFieldValue, indexItem, 'products')
              }
              variant='outlined'
              style={{ width: '100%' }}
              sx={{ mb: 2 }}
            />
            {values.conditionValue[indexItem]?.reward.products?.length ===
              0 && <ErrorSpan>Required</ErrorSpan>}
          </Box>
        </>
      )}
    </Wrapper>
  );
};

{
  /* <>
  {isNotFirstTimeOffer && !isQuickServiceProductsNotVisible && (
    <>
      <ToggleWrapper>
        <MiniToggleSwitch
          checked={isAllProductsPOSMappingIDsSelected}
          onChange={(event) => {
            setIsAllProductsPOSMappingIDsSelected(event.target.checked);
            if (event.target.checked) {
              setFieldValue(`conditionValue[${indexItem}].reward.products`, []);
            }
          }}
          disabled={values.offer_details.template_name === 'free-item'}
        />
        <span>
          {currentSource === 'quickservice'
            ? `Associate offer to all products`
            : `Associate offer to all menu`}
        </span>
      </ToggleWrapper>
    </>
  )}
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      mb: 2,
    }}
  >
    {(!isAllProductsPOSMappingIDsSelected ||
      values.offer_details.template_name === 'free-item') &&
      selectedOfferTypes?.includes('products') &&
      !isQuickServiceProductsNotVisible && (
        <>
          <NoteHead>
            {shouldShowSeparateCombos || currentSource === 'quickservice'
              ? 'Add POS mapping IDs of the Products that will be eligible for the discount.'
              : 'Add POS mapping IDs of the menu items that will be eligible for the offer.'}
          </NoteHead>
          <TextField
            multiline
            placeholder='Type POS IDs'
            name={`conditionValue[${indexItem}].reward.products`}
            value={posMappingStringValue}
            onChange={(e) =>
              handleChangeIDs(e, setFieldValue, indexItem, 'products')
            }
            variant='outlined'
            style={{ width: '100%' }}
            sx={{ mb: 2 }}
          />
          {values.conditionValue[indexItem]?.reward.products?.length === 0 && (
            <ErrorSpan>Required</ErrorSpan>
          )}
        </>
      )}
  </Box>
  {values.offer_details.template_name !== 'free-item' &&
    !isQuickServiceCombosNotVisible && (
      <ToggleWrapper
        style={{
          display: currentSource === 'quickservice' ? 'flex' : 'none',
        }}
      >
        <MiniToggleSwitch
          checked={isAllCombosPOSMappingIDsSelected}
          onChange={(event) => {
            setIsAllCombosPOSMappingIDsSelected(event.target.checked);
            if (event.target.checked) {
              setFieldValue(`conditionValue[${indexItem}].reward.combos`, []);
            }
          }}
          disabled={values.offer_details.template_name === 'free-item'}
        />
        <span>{`Associate offer to all combos`}</span>
      </ToggleWrapper>
    )}

  {currentSource === 'quickservice' && !isQuickServiceCombosNotVisible && (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: 2,
      }}
    >
      {(!isAllCombosPOSMappingIDsSelected ||
        values.offer_details.template_name === 'free-item') && (
        <>
          <NoteHead>
            Add POS mapping IDs of the combos that will be eligible for the
            discount
          </NoteHead>
          <TextField
            multiline
            placeholder='Type POS IDs'
            name={`conditionValue[${indexItem}].reward.combos`}
            value={posMappingStringValueCombos}
            onChange={(e) =>
              handleChangeIDs(e, setFieldValue, indexItem, 'combos')
            }
            variant='outlined'
            style={{ width: '100%' }}
            sx={{ mb: 2 }}
          />
          {values.conditionValue[indexItem]?.reward?.combos?.length === 0 && (
            <ErrorSpan>Required</ErrorSpan>
          )}
        </>
      )}
    </Box>
  )}

  {shouldShowSeparateCombos && (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: 2,
      }}
    >
      <NoteHead>
        Add POS mapping IDs of the Combos that will be eligible for the discount
      </NoteHead>
      {(!isAllCombosPOSMappingIDsSelected ||
        values.offer_details.template_name === 'free-item') && (
        <>
          <TextField
            multiline
            placeholder='Type POS IDs'
            name={`conditionValue[${indexItem}].reward.combos`}
            value={posMappingStringValueCombos}
            onChange={(e) =>
              handleChangeIDs(e, setFieldValue, indexItem, 'combos')
            }
            variant='outlined'
            style={{ width: '100%' }}
          />
          {values.conditionValue[indexItem]?.reward.combos?.length === 0 && (
            <ErrorSpan>Required</ErrorSpan>
          )}
        </>
      )}
    </Box>
  )}
</>; */
}
